export default __webpack_public_path__ + "e10fa8dc1375e7faa40f028473dcfa76.svg";